/**
 * BST Accordion — smooth expand/collapse for mobile nav + footer
 */
(function () {
  'use strict';

  const OPEN_CLASS = 'is-open';
  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)');

  function isFooterNavGroup(group) {
    return Boolean(group?.closest('.bst-footer__nav'));
  }

  function syncFooterDesktopState(group) {
    if (!isFooterNavGroup(group)) return;

    const isDesktop = DESKTOP_MQ.matches;
    const accordions = group.querySelectorAll('[data-bst-accordion]');

    accordions.forEach((accordion) => {
      const trigger = accordion.querySelector('[data-bst-accordion-trigger]');
      const panel = accordion.querySelector('[data-bst-accordion-panel]');
      if (!trigger || !panel) return;

      if (isDesktop) {
        accordion.classList.add(OPEN_CLASS);
        trigger.setAttribute('tabindex', '-1');
        trigger.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        return;
      }

      trigger.removeAttribute('tabindex');
      const isOpen = accordion.classList.contains(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });
  }

  function closeAccordion(accordion) {
    const trigger = accordion.querySelector('[data-bst-accordion-trigger]');
    const panel = accordion.querySelector('[data-bst-accordion-panel]');

    accordion.classList.remove(OPEN_CLASS);
    trigger?.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('aria-hidden', 'true');
  }

  function openAccordion(accordion) {
    const trigger = accordion.querySelector('[data-bst-accordion-trigger]');
    const panel = accordion.querySelector('[data-bst-accordion-panel]');

    accordion.classList.add(OPEN_CLASS);
    trigger?.setAttribute('aria-expanded', 'true');
    if (panel) panel.setAttribute('aria-hidden', 'false');
  }

  function initAccordionGroup(group) {
    if (group.closest('[data-bst-faq-page]')) return;
    if (group._bstAccordionInit) return;
    group._bstAccordionInit = true;

    const singleOpen = group.dataset.bstAccordionSingle !== 'false';
    const accordions = group.querySelectorAll('[data-bst-accordion]');
    const footerGroup = isFooterNavGroup(group);

    if (footerGroup) {
      syncFooterDesktopState(group);
      DESKTOP_MQ.addEventListener('change', () => syncFooterDesktopState(group));
    }

    accordions.forEach((accordion) => {
      const trigger = accordion.querySelector('[data-bst-accordion-trigger]');
      const panel = accordion.querySelector('[data-bst-accordion-panel]');
      if (!trigger || !panel) return;

      const isOpen = accordion.classList.contains(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

      trigger.addEventListener('click', () => {
        if (footerGroup && DESKTOP_MQ.matches) return;

        const open = accordion.classList.contains(OPEN_CLASS);

        if (singleOpen && !open) {
          accordions.forEach((other) => {
            if (other !== accordion) closeAccordion(other);
          });
        }

        if (open) closeAccordion(accordion);
        else openAccordion(accordion);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-bst-accordion-group]').forEach(initAccordionGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('bst:accordion:refresh', () => {
    document.querySelectorAll('[data-bst-accordion-group]').forEach(initAccordionGroup);
  });
})();
